module.exports = __webpack_public_path__ + "img/whatsapp-name-icon.05d3a355.svg";